import { styled, Typography } from '@mui/material';

export const StyTitle = styled(Typography, {
    name: 'StyTitle',
})(() => ({
    paddingBottom: '1.5em',
}));
